import React from 'react';
import { Page, Text, View, Image, Font } from '@react-pdf/renderer';
import Header from './Header'; // Import header
import Footer from './Footer'; // Import footer
import styles from './PagesStyle/Page1Styles'; // Import styles from PagesStyle folder
import MyCustomFont from './fonts/Roboto-BoldItalic.ttf'

Font.register({
  family: 'italicFamily',
  src: MyCustomFont
})



const Page5 = ({ formData, companyLogo}) => (
  <Page size="LETTER" style={styles.pagePage5}>
    <Header formData={formData}  companyLogo={companyLogo} />

    <View style={styles.parentContainerPage5}>
      {/* Left Column */}
      <View style={styles.leftContainerPage5}>
        <View style={styles.leftColumnPage5}>
          <View style={styles.LeftSectionPage5}>
            <Text style={[styles.TitleSectionPage5, {top: 5}]}>FRAME IDENTIFICATION</Text>
            <View style={styles.TitleBottomBorderPage5} />


            <View style={styles.containerDataPage5}>
              <View style={styles.SquareTitlePage5}>
                <Text style={styles.TitlePage5}>UNIBODY</Text>
              </View>
              <View style={styles.dataContainerPage5}>
                <View style={styles.insideLeftContainerPage5}>
                  <Text style={styles.textInsideContainerPage5}>
                    - Strut towers present {'\n'}{'\n'}
                    - Rails and floor welded together{'\n'}{'\n'}
                    - No independent rail system {'\n'}{'\n'}
                    - Aprons present {'\n'}{'\n'}
                    - Core support welded to apron
                  </Text>
                </View>
                <View style={styles.insideRightContainerPage5}>
                  <Image style={styles.imageInsideContainerPage5} src="/Unibody.png" />
                </View>
              </View>

              <View style={styles.SquareTitlePage5}>
                <Text style={styles.TitlePage5}>UNIBODY ON FRAME</Text>
              </View>
              <View style={styles.dataContainerPage5}>
                <View style={styles.insideLeftContainerPage5}>
                  <Text style={styles.textInsideContainerPage5}>
                    - Unibody bolts to frame {'\n'}{'\n'}
                    - Rails independently Bolted{'\n'}to suspension and train {'\n'}{'\n'}
                    - Has aprons {'\n'}{'\n'}
                    - No strut towers {'\n'}{'\n'}
                    - Rails tend to be thicker gauge metal (iron) {'\n'}{'\n'}
                    - Core support is typically welded to apron
                  </Text>
                </View>
                <View style={styles.insideRightContainerPage5}>
                  <Image style={styles.imageInsideContainerPage5}  src="/Bolts.png" />
                </View>
              </View>

              <View style={styles.SquareTitlePage5}>
                <Text style={styles.TitlePage5}>CONVENTIONAL FRAME</Text>
              </View>
              <View style={styles.dataContainerPage5}>
                <View style={styles.insideLeftContainerPage5}>
                  <Text style={styles.textInsideContainerPage5}>
                    - Body is not welded to frame {'\n'}{'\n'}
                    - Rails independently bolted{'\n'}to suspension and drivetrain {'\n'}{'\n'}
                    - No apron {'\n'}{'\n'}
                    - No strut towers {'\n'}{'\n'}
                    - Rails tend to be thicker gauge metal (iron) {'\n'}{'\n'}
                    - Core support is typically{'\n'}mounted by bolts only
                  </Text>
                </View>
                <View style={styles.insideRightContainerPage5}>
                  <Image style={styles.imageInsideContainerPage5}  src="/Conventional.png" />
                </View>
              </View>

              <View style={styles.SquareTitlePage5}>
                <Text style={styles.TitlePage5}>NAAA CONDITION GRADING SCALE</Text>
              </View>
              <Image style={styles.NaaImagePage5} src="/Naaa.png" />
            </View>
          </View>
        </View>
      </View>

      {/* Right Column */}
      <View style={styles.rightContainerPage5}>
        <View style={[{right: 25}]}>
          <View style={styles.rightColumnPage5}>
            <Text style={styles.RightTitlePage5}>COMPLIANCE STATEMENTS</Text>
          </View>


        <View style={[{top: 25}]}>
            <View style={[styles.rightColumnPage5, {top: 10}]}>
              <View style={styles.imageContainerPage5}>
                <Image style={styles.checkPage5} src="check.png"/>
              </View>
              <Text style={styles.paragraphPage5}>
                {'    '}{'    '}In accordance with USPAP standard 8-3, I certify that, to the best of my knowledge and belief:
              </Text>
            </View>

            <View style={[styles.rightColumnPage5, {top: 10}]}>
              <View style={styles.imageContainer2Page5}>
                <Image src="check.png"/>
              </View>
              <Text style={styles.paragraphPage5}>
                {'    '}{'    '}We have no personal interest with respect to the parties involved.
              </Text>
            </View>

            <View style={[styles.rightColumnPage5, {top: 10}]}>
              <View style={styles.imageContainer2Page5}>
                <Image src="check.png"/>
              </View>
              <Text style={styles.paragraphPage5}>
                {'    '}{'    '}The reported analysis, opinions, and conclusions are limited only by the reported assumptions
                and limiting conditions, and they represent my personal, impartial, and unbiased professional analysis,
                opinions, and conclusions.
              </Text>
            </View>

            <View style={[styles.rightColumnPage5, {top: 10}]}>
              <View style={styles.imageContainer2Page5}>
                <Image src="check.png"/>
              </View>
              <Text style={styles.paragraphPage5}>
                {'    '}{'    '}We have no present or prospective interest in the property that is the subject of this report.
              </Text>
            </View>

            <View style={[styles.rightColumnPage5, {top: 10}]}>
              <View style={styles.imageContainer2Page5}>
                <Image src="check.png"/>
              </View>
              <Text style={styles.paragraphPage5}>
                {'    '}{'    '}We have no bias with respect to any property that is the subject of this report or to the parties
                involved with this assignment.
              </Text>
            </View>

            <View style={[styles.rightColumnPage5, {top: 10}]}>
              <View style={styles.imageContainer2Page5}>
                <Image src="check.png"/>
              </View>
              <Text style={styles.paragraphPage5}>
                {'    '}{'    '}Our compensation for completing this assignment is not contingent upon the reporting of a
                predetermined value or direction in value that favors the cause of the client, the amount of the value
                opinion, the attainment of a stipulated result, or the occurrence of a subsequent event directly related
                to the intended use of this appraisal.
              </Text>
            </View>

            <View style={[styles.rightColumnPage5, {top: 10}]}>
              <View style={styles.imageContainer2Page5}>
                <Image src="check.png"/>
              </View>
              <Text style={styles.paragraphPage5}>
                {'    '}{'    '} This report is based on available third-party information known to be reliable. Our results are
                based on this information combined with the methodology outlined in the referenced patent.
              </Text>
            </View>

            <View style={[styles.rightColumnPage5, {top: 10}]}>
              <View style={styles.imageContainer2Page5}>
                <Image src="check.png"/>
              </View>
              <Text style={styles.paragraphPage5}>
                {'    '}{'    '} The values expressed herein are based on a market analysis and are not a warranty that the item
                will realize that value if offered for sale at auction or to any future value.
              </Text>
            </View>

            <View style={[styles.rightColumnPage5, {top: 10}]}>
              <View style={styles.imageContainer2Page5}>
                <Image src="check.png"/>
              </View>
              <Text style={styles.paragraphPage5}>
                {'    '}{'    '}No one provided us with significant personal property appraisal assistance.
              </Text>
            </View>

            <View style={[styles.rightColumnPage5, {top: 10}]}>
              <View style={styles.imageContainer2Page5}>
                <Image src="check.png"/>
              </View>
              <Text style={styles.paragraphPage5}>
                {'    '}{'    '}The statements of fact contained in this report are true and correct.
              </Text>
            </View>
          </View>

          <View style={[{left: 45, top: 45}]}>
            <View style={styles.tableContainerPage5}>
              <View style={styles.firstPartContainerPage5}>
                <Text style={styles.firstPartTextPage5}>COSTUMER SERVICE</Text>
              </View>
              <View style={styles.secondPartContainerPage5}>
                <Text style={styles.secondPartTextPage5}>(678) 805-4066</Text>
                <Text style={styles.secondPartMailPage5}>reports@appraisalengine.com</Text>
              </View>
            </View>

            <View style={styles.checkboxPage5}>
              {formData.checkboxYes ? (
                // Display the filled checkbox (e.g., a checkmark or another symbol) if selected
                <Text style={[styles.checkmarkPage5, { fontSize: 14 }]}>✔</Text>
              ) : (
                // Don't display anything when not selected (or show an empty box as needed)
                <View style={styles.uncheckedBoxPage5} />
              )}
            </View>
            <View style={styles.finaltextContainerPage5}>
              <Text style={styles.yesPage5}>Yes</Text>
              <Text style={styles.InspectionPage5}>
                A personal inspection of the properties that {'\n'}
                are the subject of this report was performed.
              </Text>
            </View>
          </View>
        </View>

      </View>
    </View>

    <Footer pageNumber={5}/>
  </Page>
);

export default Page5;